"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TitledLoadingPage;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _LoadingPaper = _interopRequireDefault(require("../LoadingPaper"));
var _NavTabs = _interopRequireDefault(require("../NavTabs"));
var _Page = _interopRequireDefault(require("../Page"));
var _PageTitle = _interopRequireDefault(require("../PageTitle"));
function TitledLoadingPage(_ref) {
  var hasBackButton = _ref.hasBackButton,
    id = _ref.id,
    tabs = _ref.tabs,
    titleKey = _ref.titleKey;
  var _useParams = (0, _reactRouterDom.useParams)(),
    _useParams$viewId = _useParams.viewId,
    viewId = _useParams$viewId === void 0 ? '' : _useParams$viewId;
  return /*#__PURE__*/_react.default.createElement(_Page.default, {
    id: id,
    titleKey: titleKey
  }, titleKey && /*#__PURE__*/_react.default.createElement(_PageTitle.default, {
    back: hasBackButton,
    id: "".concat(id, "Title"),
    titleKey: titleKey
  }), tabs && /*#__PURE__*/_react.default.createElement(_NavTabs.default, {
    id: id,
    tabs: tabs,
    value: viewId
  }), /*#__PURE__*/_react.default.createElement(_LoadingPaper.default, {
    id: "".concat(id, "Paper")
  }));
}